export default __webpack_public_path__ + "static/media/How_To_Find_Post_ID.2c2b0eb5.jpg";